(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/create-game/assets/javascripts/services/update-game.js') >= 0) return;  svs.modules.push('/components/marketplace-data/create-game/assets/javascripts/services/update-game.js');
"use strict";


const {
  jupiter
} = svs.core;
const updateGame = (game, callback) => {
  const data = {
    maxSharesPerMember: game.maxFractionsPerMember,
    description: game.description
  };
  if (game.buyStop) {
    data.buyinCloseTime = "".concat(dateFns.formatISO(new Date(game.buyStop)).split('.')[0], "Z"); 
  }
  jupiter.put({
    path: "/marketplace/1/activateddraws/".concat(game.activatedDrawId),
    data
  }, () => callback(undefined, game), error => callback(error.responseJSON.error, undefined));
};
setGlobal('svs.components.marketplaceData.createGame.services.updateGame', updateGame);

 })(window);